import type { ExecutionStatus } from '@/shared/api/execution';
import type { RunStatus } from '@/shared/ui/RunStatusTag';

export function mapExecutionStatusToRunStatus(status: ExecutionStatus): RunStatus {
  switch (status) {
    case 'execution_queued':
    case 'execution_running':
      return 'execution_running';
    case 'execution_succeeded':
      return 'execution_succeeded';
    case 'execution_failed':
      return 'execution_failed';
    case 'execution_canceled':
      return 'execution_canceled';
    default:
      return 'execution_ready';
  }
}
